const initialState = {
isLoading: true,
requests:[]
}
export default initialState;